import React from "react";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { EGIconButton } from "../../../../../../MainComponents/Button/IconButton/IconButton";

export const PreviewFile = ({ show, theme, selectPreviewFile, t, onClose }) => {
  // Direct file preview
  const PreviewRenderer = ({ file }) => {
    if (!file) return null;

    const type = file.attachments_data?.type || "";
    const url = file.file_url;
    // If there is no URL → no preview possible
    if (!url) {
      return (
        <Typography color="error">
          {t("Interview.no_file_available_for_preview")}
        </Typography>
      );
    }
    // If there is no type → we don't know how to render
    if (!type) {
      return (
        <Typography color="error">
          {t("Interview.no_file_available_for_preview")}
        </Typography>
      );
    }

    // PDF
    if (type === "application/pdf") {
      return (
        <iframe
          title="pdf-preview"
          src={url}
          style={{
            width: "100%",
            height: "80vh",
            border: "none",
          }}
        />
      );
    }

    // Documentos Office (docx, xlsx, pptx…)
    if (type.includes("application/vnd.openxmlformats-officedocument")) {
      const encodedUrl = encodeURIComponent(url);

      return (
        <iframe
          title="office-preview"
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`}
          style={{
            width: "100%",
            height: "80vh",
            border: "none",
          }}
        />
      );
    }

    // Images
    if (type.startsWith("image/")) {
      return (
        <img
          src={url}
          alt={file.attachments_data?.name}
          style={{ width: "100%", height: "auto" }}
        />
      );
    }

    // Fallback → type no support
    return (
      <Typography color="error">
        {t("Interview.no_file_available_for_preview")}
      </Typography>
    );
  };

  return (
    <Dialog open={show} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          borderBottom: `1px solid ${theme.palette.blueGray50?.main}`,
        }}
      >
        <Typography component="span" fontWeight={600} fontSize={20}>
          {selectPreviewFile?.attachments_data.name || ""}
        </Typography>
        <EGIconButton
          iconName="cancel_circle"
          iconColor="primary"
          onClick={onClose}
          sx={{ position: "absolute", top: 15, right: 12 }}
          iconSize={25}
        />
      </DialogTitle>
      <DialogContent>
        {selectPreviewFile ? (
          <PreviewRenderer file={selectPreviewFile} />
        ) : (
          <Typography color="error">
            {t("Interview.no_file_available_for_preview")}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};
